/* Sección de cierre (Low Ticket): aparición suave al hacer scroll. Si algo falla, todo se muestra igualmente. */
(function () {
  var roots = document.querySelectorAll('.lcl');
  for (var r = 0; r < roots.length; r++) {
    (function (root) {
      try {
        var els = root.querySelectorAll('[data-rv]');
        if (!('IntersectionObserver' in window)) { root.classList.add('lcl--show'); return; }
        var io = new IntersectionObserver(function (entries) {
          var k = 0;
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            en.target.style.setProperty('--i', Math.min(k++, 6));
            en.target.classList.add('is-in');
            io.unobserve(en.target);
          });
        }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });
        for (var i = 0; i < els.length; i++) { io.observe(els[i]); }
      } catch (e) {
        root.classList.add('lcl--show');
      }
    })(roots[r]);
  }
})();